import React from 'react';
import styles from './RegisterForm.module.css';

const ButtonsRegister = ({ page, setPage, check }) => {
    return (
        <div className={styles.containerBtn}>
            <button
                type='button'
                className={styles.btn}
                onClick={() => setPage(page - 1)}
                disabled={page === 0}
            >Retour
            </button>
                
            <button
                className={styles.btn}
                style={{
                    backgroundColor:
                    (page === 1 && check) || (page === 2 && !check)
                    ? "rgb(36, 127, 46)"
                    : "rgb(31, 111, 235)"
                    }}
                >
                {(page === 1 && check) || (page === 2 && !check)
                ? "S'inscrire"
                : "Suivant"}
            </button>
        </div>
    );
};

export default ButtonsRegister;